export default __webpack_public_path__ + "static/media/Vending5.9707eb59.png";